import React, { useState } from "react";
import "./Exec1.css";

const teamMembers = [
  {
    id: "sujatha",
    name: "Sujatha Tadiboyna",
    title: "FOUNDER & CHAIRPERSON",
    image: "/assests/sujatha.jpg",
    bio: `Sujatha Tadiboyna is a seasoned IT professional and visionary entrepreneur with 25+ years of experience in the technology industry. She has successfully led teams, delivered strategic technology initiatives, and worked with leading clients across the USA, UK, Australia and India, consistently turning business objectives into achievable results.

With a Master’s degree and extensive expertise in software solutions, business strategy, and technology leadership, Sujatha brings a strong combination of technical knowledge, strategic vision, and entrepreneurial leadership. As the Founder and Managing Director, she is committed to driving innovation, building high-performing teams, and delivering scalable, customer-focused software solutions that create lasting business value.`,
  },
  {
    id: "harika",
    name: "Harika Tadiboyna",
    title: "CHIEF EXECUTIVE OFFICER",
    image: "/assests/harika.jpg",
    bio: `Harika Tadiboyna is a dynamic and emerging entrepreneur with a strong passion for technology, healthcare, and innovation. As a young business leader, she brings a fresh perspective, entrepreneurial mindset, and broad exposure to both the technology and healthcare sectors.

Currently pursuing her MBBS, Harika combines her growing medical knowledge with an interest in technology-driven solutions, enabling her to understand the evolving needs of the healthcare industry. As Chief Executive Officer, she focuses on strategic growth, innovation, customer success, and building a forward-thinking organization.

With her energy, vision, and commitment to continuous learning, Harika represents the next generation of technology and healthcare leadership.`,
  },
  {
    id: "krishna",
    name: "Krishna Reddy",
    title: "CHIEF TECHNOLOGY OFFICER",
    image: "/assests/image.jpg",
    bio: `Krishna Reddy is a distinguished technology leader with 20+ years of expertise in IT strategy, enterprise data, analytics, and digital transformation. With extensive experience collaborating with leading organizations across the USA and Canada, he has successfully driven the architecture, development, and delivery of enterprise-grade technology solutions that enable innovation, operational excellence, and sustainable business growth.

As Chief Technology Officer, Krishna drives the organization’s technology vision, architecture, innovation, engineering excellence, and global delivery strategy. He focuses on leveraging emerging technologies, including Artificial Intelligence and advanced analytics, to build secure, scalable, high-performance solutions and deliver measurable business value to clients worldwide.`,
  },
  {
    id: "jagan",
    name: "Prof. B Jagan Mohan Reddy",
    title: "SENIOR DIRECTOR - ADVISORY",
    image: "/assests/jagan_mohan.jpg",
    bio: `Professor Boggu Jagan Mohan Reddy is a distinguished academic and research professional, serving as a Professor in the Department of Chemistry and Chairman of the Board of Studies for P.G. Chemistry at Adikavi Nannaya University, Rajahmundry, Andhra Pradesh.

He holds a Ph.D. in Chemistry and completed a Post-Doctoral Fellowship at the Pohang University of Science and Technology (POSTECH), South Korea, along with an MBA from Andhra University. His academic and research expertise spans Organic Chemistry, Catalysis, Research & Innovation, and interdisciplinary technology applications.

As a Technology Advisor to the Division of PINKMOON Technologies, he provides strategic guidance on innovation, emerging technologies, research-driven solutions, and technology initiatives, supporting the organization’s vision of developing impactful and future-ready solutions.`,
  },
  {
    id: "suresh",
    name: "Suresh Babu M",
    title: "HR, LEGAL & COMPLIANCE OFFICER",
    image: "/assests/suresh_babu.jpg",
    bio: `M. Suresh Babu is a distinguished Advocate, Additional Government Pleader (AGP), and Legal Advisor with 25+ years of professional experience. He has represented individuals, businesses, and organizations at the Guntur District Court, specialized courts, and tribunals. He has served as a trusted legal advisor to numerous companies and clients, providing guidance on corporate law, litigation, contracts, labour matters, compliance, and regulatory affairs. He has also held leadership roles within the Guntur Bar Association. His extensive legal expertise and strategic approach make him a valued advisor in legal, governance, and risk-management matters.`,
  },
  {
    id: "harshitha",
    name: "Dr. Allu Harshitha",
    title: "VICE PRESIDENT",
    image: "/assests/harshitha.jpg",
    bio: `Dr. A. Harshitha is an accomplished academic, researcher, and emerging technology leader with expertise in Mechanical Engineering, materials research, innovation, and interdisciplinary technologies. She holds a Ph.D. in Mechanical Engineering, along with B.E., M.E., M.A. in Psychology, and a Post Graduate Diploma in Disaster Management. With 10+ years of teaching and academic experience, she has contributed extensively to research, mentoring, and technology-driven initiatives. She has authored books, published 9 international research articles, and participated in numerous international seminars and technology programs. Her exposure to AI, machine learning, advanced manufacturing, robotics, healthcare technologies, and sustainable engineering brings a strong interdisciplinary perspective to the organization. As Vice President of PINKMOON Technologies, she contributes to strategic initiatives, innovation, research, and the development of future-ready technology solutions.`,
  },
];

const ExecutiveTeam = () => {
  const [activeMemberId, setActiveMemberId] = useState(null);

  const activeMember = teamMembers.find((m) => m.id === activeMemberId);

  const topRowMembers = teamMembers.slice(0, 3);
  const bottomRowMembers = teamMembers.slice(3, 6);

  const isBottomRowActive = bottomRowMembers.some(
    (m) => m.id === activeMemberId
  );

  const getCaretPosition = (id) => {
    switch (id) {
      case "sujatha":
      case "jagan":
        return "16.66%";
      case "harika":
      case "suresh":
        return "50%";
      case "krishna":
      case "harshitha":
        return "83.33%";
      default:
        return "50%";
    }
  };

  return (
    <div className="executive-team">
      <div className="team-header section-header">
        <div className="team-label section-label">
          <svg className="team-label-icon" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
              fill="currentColor"
            />
          </svg>
          <span>Executive Team</span>
        </div>

        <h2 className="team-title section-title">Executive Team</h2>
        <p className="team-subtitle section-description">
          With more than two decades of expertise in the IT sector, our
          executive leadership team provides strategic direction and proven
          industry insight.
        </p>
      </div>

      <div
        className="team-container"
        onMouseLeave={() => setActiveMemberId(null)}
      >
        {/* Top Row Cards */}
        <div className="team-row-grid">
          {topRowMembers.map((member) => {
            const isActive = activeMemberId === member.id;
            return (
              <div
                key={member.id}
                className={`exec-card-item ${isActive ? "active" : ""}`}
                onMouseEnter={() => setActiveMemberId(member.id)}
              >
                <div className="exec-photo-wrapper">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="exec-photo-img"
                  />
                </div>
                <div className="exec-meta-wrapper">
                  <h3 className="exec-member-name">{member.name}</h3>
                  <span className="exec-member-title">{member.title}</span>
                </div>
              </div>
            );
          })}
        </div>

        {/* Dedicated Middle Bio Drawer Slot */}
        <div className="team-middle-drawer-slot">
          {activeMember && (
            <div className="team-bio-panel-drawer">
              <div
                className={`bio-panel-pointer ${
                  isBottomRowActive ? "pointer-bottom" : "pointer-top"
                }`}
                style={{
                  left: getCaretPosition(activeMember.id),
                }}
              ></div>
              <button
                className="bio-panel-close-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  setActiveMemberId(null);
                }}
                aria-label="Close"
              >
                ✕
              </button>
              <div className="bio-panel-content-inner">
                <div className="bio-panel-left">
                  <h3 className="bio-panel-name">{activeMember.name}</h3>
                  <span className="bio-panel-title">{activeMember.title}</span>
                </div>
                <div className="bio-panel-right">
                  <p className="bio-panel-desc">{activeMember.bio}</p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Bottom Row Cards */}
        <div className="team-row-grid team-row-bottom">
          {bottomRowMembers.map((member) => {
            const isActive = activeMemberId === member.id;
            return (
              <div
                key={member.id}
                className={`exec-card-item ${isActive ? "active" : ""}`}
                onMouseEnter={() => setActiveMemberId(member.id)}
              >
                <div className="exec-photo-wrapper">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="exec-photo-img"
                  />
                </div>
                <div className="exec-meta-wrapper">
                  <h3 className="exec-member-name">{member.name}</h3>
                  <span className="exec-member-title">{member.title}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ExecutiveTeam;
